import { MigrationManifest, PersistedState } from 'redux-persist';

import v0 from './v0';
import v1 from './v1';
import v2 from './v2';
import v3 from './v3';
import v4 from './v4';
import v5 from './v5';
import v6 from './v6';
import v7 from './v7';
import v8 from './v8';
import v9 from './v9';
import v10 from './v10';
import v11 from './v11';
import v12 from './v12';
import v13 from './v13';
import v14 from './v14';
import v15 from './v15';
import v16 from './v16';
import v17 from './v17';
import v18 from './v18';
import v19 from './v19';
import v20 from './v20';
import v21 from './v21';
import v23 from './v23';
import v25 from './v25';
import v26 from './v26';
import v27 from './v27';
import v28 from './v28';
import v29 from './v29';
import v30 from './v30';
import v31 from './v31';
import v32 from './v32';
import v33 from './v33';
import v34 from './v34';
import v35 from './v35';
import v36 from './v36';
import v37 from './v37';
import v38 from './v38';
import v39 from './v39';
import v40 from './v40';
import v41 from './v41';
import v42 from './v42';

export const currentStoreVersion = 42;

const migrations = {
  0: v0 as unknown as (state: PersistedState) => PersistedState,
  1: v1 as unknown as (state: PersistedState) => PersistedState,
  2: v2 as unknown as (state: PersistedState) => PersistedState,
  3: v3 as unknown as (state: PersistedState) => PersistedState,
  4: v4 as unknown as (state: PersistedState) => PersistedState,
  5: v5 as unknown as (state: PersistedState) => PersistedState,
  6: v6 as unknown as (state: PersistedState) => PersistedState,
  7: v7 as unknown as (state: PersistedState) => PersistedState,
  8: v8 as unknown as (state: PersistedState) => PersistedState,
  9: v9 as unknown as (state: PersistedState) => PersistedState,
  10: v10 as unknown as (state: PersistedState) => PersistedState,
  11: v11 as unknown as (state: PersistedState) => PersistedState,
  12: v12 as unknown as (state: PersistedState) => PersistedState,
  13: v13 as unknown as (state: PersistedState) => PersistedState,
  14: v14 as unknown as (state: PersistedState) => PersistedState,
  15: v15 as unknown as (state: PersistedState) => PersistedState,
  16: v16 as unknown as (state: PersistedState) => PersistedState,
  17: v17 as unknown as (state: PersistedState) => PersistedState,
  18: v18 as unknown as (state: PersistedState) => PersistedState,
  19: v19 as unknown as (state: PersistedState) => PersistedState,
  20: v20 as unknown as (state: PersistedState) => PersistedState,
  21: v21 as unknown as (state: PersistedState) => PersistedState,
  23: v23 as unknown as (state: PersistedState) => PersistedState,
  25: v25 as unknown as (state: PersistedState) => PersistedState,
  26: v26 as unknown as (state: PersistedState) => PersistedState,
  27: v27 as unknown as (state: PersistedState) => PersistedState,
  28: v28 as unknown as (state: PersistedState) => PersistedState,
  29: v29 as unknown as (state: PersistedState) => PersistedState,
  30: v30 as unknown as (state: PersistedState) => PersistedState,
  31: v31 as unknown as (state: PersistedState) => PersistedState,
  32: v32 as unknown as (state: PersistedState) => PersistedState,
  33: v33 as unknown as (state: PersistedState) => PersistedState,
  34: v34 as unknown as (state: PersistedState) => PersistedState,
  35: v35 as unknown as (state: PersistedState) => PersistedState,
  36: v36 as unknown as (state: PersistedState) => PersistedState,
  37: v37 as unknown as (state: PersistedState) => PersistedState,
  38: v38 as unknown as (state: PersistedState) => PersistedState,
  39: v39 as unknown as (state: PersistedState) => PersistedState,
  40: v40 as unknown as (state: PersistedState) => PersistedState,
  41: v41 as unknown as (state: PersistedState) => PersistedState,
  42: v42 as unknown as (state: PersistedState) => PersistedState,
} as MigrationManifest;

export default migrations;
